export default "__VITE_ASSET__CgSh0abe__"